<template>
  <div class="course-list-wrapper">
    <div class="course-list-inner-wrapper">
      <v-slide-y-transition>
        <v-row v-if="!showWeekly && schwandenStudio" justify="center">
          <v-col cols="12" style="max-width: 500px">
            <v-alert border="left" color="blue-grey darken-3" class="mx-4"> Groupfitness im well come FIT Netstal </v-alert>
          </v-col>
        </v-row>
      </v-slide-y-transition>

      <course-list-weekly @toDailyView="showWeekly = false" :key="courseListWeeklyKey" v-if="showWeekly"></course-list-weekly>

      <div v-else class="daily-view-container">
        <v-card flat color="transparent" class="date-picker-card mx-auto">
          <v-card-actions class="d-flex justify-space-between align-center px-4">
            <v-btn :disabled="isPrevDayDisabled" icon @click="swipe('Right')"><v-icon>mdi-chevron-left</v-icon></v-btn>

            <v-dialog width="auto" v-model="showDatePicker">
              <template v-slot:activator="{ on, attrs }">
                <v-btn text large v-bind="attrs" v-on="on">
                  <v-icon left>mdi-calendar-blank</v-icon>
                  <span style="font-weight: 1000">{{ formatDate(datePicker) }}</span>
                </v-btn>
              </template>

              <v-card class="mx-auto" max-width="380" width="90vw">
                <div v-if="!userService.hasRight('gf_f_courses')">
                  <v-list dense nav>
                    <v-list-item-group style="max-height: 400px; overflow-y: scroll" v-model="datePicker" color="primary">
                      <v-list-item v-for="day in customerDateRange" :key="day.value" :value="day.value" class="date-list-item">
                        <v-list-item-content>
                          <v-list-item-title>{{ day.text }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>

                  <v-divider></v-divider>

                  <v-list dense nav>
                    <v-list-item @click="toWeeklyView()" class="date-list-item">
                      <v-list-item-icon>
                        <v-icon>mdi-view-week-outline</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>Zur Wochenansicht</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </div>

                <div v-else class="d-flex justify-center flex-column">
                  <v-date-picker
                    v-model="datePicker"
                    color="primary"
                    locale="de-CH"
                    no-title
                    class="mx-auto"
                    :min="minDate"
                    :max="maxDate"></v-date-picker>

                  <div>
                    <v-divider></v-divider>

                    <v-list-item
                      dense
                      v-if="userService.hasRight('gf_c_edit', 'gf_c_delete', 'gf_c_plan', 'gf_c_create', 'gf_cp_edit')"
                      @click="$router.push('/kurslisten')">
                      <v-list-item-icon>
                        <v-icon color="primary">mdi-calendar-edit</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>Kursplan verwalten</v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-icon>mdi-chevron-right</v-icon>
                      </v-list-item-action>
                    </v-list-item>
                    <v-list-item dense @click="toWeeklyView()">
                      <v-list-item-icon>
                        <v-icon color="primary">mdi-calendar</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>zur Wochenansicht</v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-icon>mdi-chevron-right</v-icon>
                      </v-list-item-action>
                    </v-list-item>
                  </div>
                </div>
              </v-card>
            </v-dialog>
            <v-btn :disabled="isNextDayDisabled" icon @click="swipe('Left')"><v-icon>mdi-chevron-right</v-icon></v-btn>
          </v-card-actions>
        </v-card>

        <v-slide-y-transition>
          <v-card v-if="!loadingKinderhort && showDaycare" class="kinderhort-card mx-4 my-4">
            <div v-if="!showDaycareSelect">
              <v-card-title style="font-weight: 1000; font-style: italic" class="text-uppercase"
                >Kinderhort
                <span class="pl-2" v-if="daycareSettings && daycareSettings.notes && daycareSettings.notes.length > 2 && !showDaycareSelect">
                  <v-tooltip color="primary" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon color="white" dark v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
                    </template>
                    <span>{{ daycareSettings.notes }}</span>
                  </v-tooltip>
                </span></v-card-title
              >

              <v-card-subtitle v-html="daycareHours"></v-card-subtitle>
              <div class="kinderhort-icon-wrapper">
                <img v-if="!showDaycareSelect" class="icon" src="/img/icons/teddyBear.gif" />
                <img v-if="!showDaycareSelect" class="icon2" src="/img/icons/teddyBear.gif" />
              </div>
              <v-card-actions class="pa-4">
                <v-btn :disabled="daycareClosed" block large color="white" class="cta-button primary--text" @click="showDaycareSelect = true">
                  <span v-if="!daycareClosed">
                    <v-icon left>mdi-teddy-bear</v-icon>{{ daycareSignedUp ? "Anmeldung bearbeiten" : "Jetzt anmelden" }}</span
                  >
                  <span v-else> <v-icon left>mdi-clock-outline</v-icon> Für heute vorbei </span>
                </v-btn>
              </v-card-actions>
            </div>
            <div v-else>
              <v-toolbar flat color="transparent">
                <v-toolbar-title class="white--text text-uppercase" style="font-weight: 1000; font-style: italic"
                  >Kinderhort Anmeldung</v-toolbar-title
                >
                <v-spacer></v-spacer>
                <v-btn class="white--text" icon @click="showDaycareSelect = false"><v-icon>mdi-close</v-icon></v-btn>
              </v-toolbar>
              <v-card-text class="mt-0 pt-0">
                <v-alert
                  type="info"
                  text
                  width="100%"
                  border="left"
                  color="white"
                  class="d-flex align-center font-weight-bold"
                  v-if="daycareSettings && daycareSettings.notes && daycareSettings.notes.length > 2 && showDaycareSelect">
                  {{ daycareSettings.notes }}
                </v-alert>
                <v-select dark dense outlined v-model="arrivalTime" :items="daycareTimeSlots" label="Ankunftszeit" suffix="Uhr"></v-select>
                <div class="d-flex">
                  <v-select
                    hide-details
                    dark
                    dense
                    outlined
                    class="pr-2"
                    v-model="daycareSelection"
                    :items="daycareChildrenSelect"
                    label="Kinder"></v-select>
                  <v-select
                    hide-details
                    dark
                    dense
                    outlined
                    v-model="daycareBabiesSelection"
                    :items="daycareBabiesSelect"
                    label="Babies (bis 1.5 Jahre)"></v-select>
                </div>
              </v-card-text>
              <v-card-actions class="px-4 pb-4">
                <v-btn block large color="white" class="cta-button primary--text" @click="signupDaycare()">
                  <v-icon left>mdi-teddy-bear</v-icon>
                  Anmeldung speichern
                </v-btn>
              </v-card-actions>
            </div>
          </v-card>
        </v-slide-y-transition>

        <div v-if="loading" class="text-center py-16">
          <v-progress-circular indeterminate color="primary" size="48"></v-progress-circular>
        </div>
        <div v-else>
          <v-alert
            text
            width="100%"
            border="left"
            color="primary"
            class="d-flex align-center mt-2 font-weight-bold"
            v-if="courseList.length === 0"
            type="info"
            >Keine Kurse an diesem Tag gefunden</v-alert
          >
          <v-slide-y-transition group>
            <div
              v-show="!course.cancelled || (course.cancelled && course.cancelledVisibility) || userService.hasRight('gf_c_plan')"
              v-for="(course, y) in courseList"
              :key="course._id || y"
              class="course-entry-wrapper mx-4">
              <div v-if="showDivider(y)" class="time-divider">
                <span class="time-chip">ab {{ course.hours }} Uhr</span>
              </div>
              <v-card
                @click="pushToCourse(course)"
                class="course-card my-3"
                :class="{
                  'signed-up': course.signedUp && !course.onQueue,
                  'on-queue': course.signedUp && course.onQueue,
                  'is-cancelled': course.cancelled,
                  'is-past': course.past && !course.visited,
                }"
                outlined>
                <v-chip
                  v-if="course.cancelled && !course.cancelledVisibility"
                  small
                  color="red"
                  class="white--text"
                  style="position: absolute; height: 20px; top: -10px; left: 50%; transform: translateX(-50%)"
                  ><span style="text-transform: uppercase; font-weight: 1000; font-style: italic">Ausgeblendet</span></v-chip
                >
                <v-chip
                  v-if="course.signedUp && !course.onQueue && !(course.label && course.label.text) && !isLive(course)"
                  small
                  color="primary"
                  style="position: absolute; height: 20px; top: -10px; left: 50%; transform: translateX(-50%)"
                  ><span style="text-transform: uppercase; font-weight: 1000; font-style: italic">Angemeldet</span></v-chip
                >
                <v-chip
                  v-if="course.signedUp && course.onQueue && !isLive(course)"
                  small
                  color="orange"
                  style="position: absolute; height: 20px; top: -10px; left: 50%; transform: translateX(-50%)"
                  ><span style="color: white; text-transform: uppercase; font-weight: 1000; font-style: italic">Warteliste</span></v-chip
                >
                <v-chip
                  v-if="!course.signedUp && course.signupAmount >= course.amount && !isLive(course) && !(course.label && course.label.text)"
                  small
                  color="#313131"
                  style="position: absolute; height: 20px; top: -10px; left: 50%; transform: translateX(-50%)"
                  ><span style="color: white; text-transform: uppercase; font-weight: 1000; font-style: italic">Warteliste verfügbar</span></v-chip
                >
                <v-chip v-if="false && course.cancelled" small color="red darken-2" text-color="white" class="status-chip">leider abgesagt</v-chip>
                <v-chip
                  small
                  v-if="isLive(course) && !(course.label && course.label.text)"
                  class="white--text"
                  style="position: absolute; height: 20px; top: -10px; left: 50%; transform: translateX(-50%)"
                  color="red">
                  <span style="color: white; text-transform: uppercase; font-weight: 1000; font-style: italic"> LIVE</span>
                </v-chip>
                <v-chip
                  small
                  v-if="course.label && course.label.text && (!(course.signupAmount >= course.amount && course.onQueue) || !course.reqSignup)"
                  class="white--text"
                  style="position: absolute; height: 20px; top: -10px; left: 50%; transform: translateX(-50%)"
                  :color="course.label.color">
                  <span style="color: white; text-transform: uppercase; font-weight: 1000; font-style: italic"> {{ course.label.text }}</span>
                </v-chip>
                <div class="course-card-marker" :style="{ backgroundColor: getMarkerColor(course) }"></div>
                <v-list-item three-line>
                  <v-list-item-avatar size="60" class="course-avatar my-auto">
                    <lottie-player
                      v-if="course.icon"
                      mode="normal"
                      class="ma-auto"
                      style="width: 52px; height: 66px"
                      :src="'/api/gf/icons/' + course.icon"
                      :key="course.icon"></lottie-player>
                    <lottie-player v-else mode="normal" style="width: 52px; height: 66px" src="/img/lottiefiles/gf/dumbell.json"></lottie-player>
                  </v-list-item-avatar>
                  <v-list-item-content style="align-self: center">
                    <v-list-item-title style="font-weight: 1000" class="text-h6 mb-1 d-flex align-center"
                      ><v-icon class="mr-2" color="red" v-if="course && shouldShowClaimButton(course)">mdi-invoice-text-clock</v-icon
                      >{{ course?.course?.name }}

                      <v-icon v-if="course?.course?._id && courseRecommendations.includes(course.course._id)" color="amber" class="ml-2" small>
                        mdi-star
                      </v-icon></v-list-item-title
                    >

                    <v-list-item-subtitle>{{ course.instructors.map((i) => i.vorname).join(", ") }}</v-list-item-subtitle>

                    <v-list-item-subtitle>{{ courseStartDate(course) }} - {{ courseEndDate(course) }} Uhr</v-list-item-subtitle>
                    <v-list-item-subtitle v-if="course?.room?.name">
                      <span>
                        <v-icon x-small color="grey darken-2" class="mr-0">mdi-map-marker</v-icon>
                        <span class="text-capitalize pl-1">{{ course.room.name }}</span>
                      </span>
                    </v-list-item-subtitle>
                    <v-list-item-subtitle v-if="course.additionalInfo" class="additional-info align-start mt-2 d-flex">
                      <v-icon left small>mdi-information-outline</v-icon>
                      <span>{{ course.additionalInfo }}</span>
                    </v-list-item-subtitle>
                    <v-list-item-subtitle v-if="course.cancelled" class="additional-info align-start mt-2 d-flex">
                      <v-icon left small>mdi-information-outline</v-icon>
                      <span> Infolge zu geringer Nachfrage leider abgesagt </span>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action class="align-self-center">
                    <div v-if="course.past && course.visited && !course.ratings" class="text-center">
                      <v-dialog transition="dialog-bottom-transition" max-width="480" content-class="rate-dialog">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn class="rate-btn" depressed v-bind="attrs" v-on="on" @click="hideGoogleRating()">
                            <v-icon left small>mdi-star</v-icon>
                            Bewerten
                          </v-btn>
                        </template>
                        <template v-slot:default="dialog">
                          <v-card class="rate-card">
                            <!-- Header mit Gradient -->
                            <div class="rate-header">
                              <div class="rate-header-content">
                                <div class="rate-course-name">{{ course.course.name }}</div>
                                <div class="rate-course-meta">mit {{ course.instructors.map((i) => i.vorname).join(", ") }}</div>
                              </div>
                              <v-btn icon small class="rate-close" @click="abortRatingDialog(dialog)">
                                <v-icon color="white">mdi-close</v-icon>
                              </v-btn>
                            </div>

                            <v-card-text class="pt-6 pb-2">
                              <!-- Sternebewertung -->
                              <div v-if="!rating.showGoogle && !rating.showFeedbackBox">
                                <p class="rate-question text-center mb-2">Wie war dein Kurs?</p>
                                <div class="d-flex justify-center mb-4">
                                  <v-rating
                                    background-color="grey lighten-2"
                                    color="amber darken-1"
                                    hover
                                    size="35"
                                    v-model="rating.stars"></v-rating>
                                </div>
                                <v-textarea
                                  v-model="rating.message"
                                  outlined
                                  rounded
                                  auto-grow
                                  rows="3"
                                  hide-details
                                  :placeholder="
                                    rating.stars && rating.stars <= 3
                                      ? 'Bitte teile uns mit, was wir verbessern können (erforderlich)...'
                                      : 'Erzähl uns mehr (optional)...'
                                  "></v-textarea>
                              </div>

                              <!-- Google Bewertung -->
                              <div v-if="rating.showGoogle" class="text-center">
                                <v-icon size="56" color="amber darken-1" class="mb-2">mdi-star-circle</v-icon>
                                <p class="rate-question">Vielen Dank für deine Bewertung!</p>
                                <p class="grey--text text--darken-1 mb-3">Wir würden uns sehr freuen, wenn du uns auch auf Google bewertest.</p>
                                <v-checkbox
                                  v-model="rating.dontShowAnymore"
                                  label="Nicht mehr anzeigen"
                                  hide-details
                                  class="d-inline-flex"></v-checkbox>
                              </div>

                              <!-- Feedback Box -->
                              <div v-if="rating.showFeedbackBox">
                                <p class="rate-question text-center">Schade, dass du nicht ganz zufrieden warst.</p>
                                <p class="grey--text text--darken-1 text-center mb-4">Was können wir besser machen?</p>
                                <v-textarea
                                  v-model="rating.inputFeedbackBox"
                                  outlined
                                  rounded
                                  auto-grow
                                  rows="4"
                                  hide-details
                                  placeholder="Deine Rückmeldung..."></v-textarea>
                              </div>
                            </v-card-text>

                            <v-card-actions class="px-6 pb-5 pt-3">
                              <v-btn text class="rate-cancel" @click="abortRatingDialog(dialog)">Abbrechen</v-btn>
                              <v-spacer></v-spacer>
                              <v-btn
                                class="rate-submit"
                                depressed
                                large
                                :loading="loadingFeedback"
                                @click="
                                  !rating.showGoogle
                                    ? !rating.showFeedbackBox
                                      ? sendRating(course._id, dialog)
                                      : sendFeedbackBox(dialog, course._id)
                                    : openGoogleRating(dialog)
                                ">
                                <v-icon left>{{ rating.showGoogle ? "mdi-google" : rating.showFeedbackBox ? "mdi-send" : "mdi-star" }}</v-icon>
                                <span v-if="!rating.showGoogle && !rating.showFeedbackBox">Bewerten</span>
                                <span v-else-if="rating.showGoogle">Zu Google</span>
                                <span v-else>Absenden</span>
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </template>
                      </v-dialog>
                    </div>

                    <div v-else-if="course.past && course.ratings" class="text-center">
                      <v-rating :value="course.ratings.stars" color="amber" dense readonly size="20"></v-rating>
                      <div class="text-caption grey--text mt-1">Bewertet</div>
                    </div>

                    <div v-if="!(course.past && (course.visited || course.ratings))" class="align-self-center ma-0">
                      <div v-if="false && course.cancelled" class="text-center">
                        <v-avatar color="red" size="44">
                          <v-icon color="white">mdi-close</v-icon>
                        </v-avatar>
                      </div>
                      <div v-else-if="false && course.signedUp" class="text-center">
                        <v-avatar color="primary" size="44">
                          <v-icon color="white">mdi-check-bold</v-icon>
                        </v-avatar>
                      </div>
                      <div v-else class="text-center">
                        <div v-if="course.reqSignup !== false && !course.cancelled">
                          <div>
                            <v-progress-circular
                              v-if="!course.onQueue && (!(course.signupAmount >= course.amount) || course.signedUp)"
                              :value="calcPercentage(course)"
                              :color="getIndicatorColor(calcPercentage(course))"
                              size="50"
                              width="4">
                              <span class="font-weight-bold">
                                <span>{{ displayedSignupAmount(course) }}/{{ course.amount || 0 }}</span>
                              </span>
                            </v-progress-circular>

                            <div class="text-caption grey--text mt-1" style="line-height: 1.2">
                              <div v-if="course.signedUp && !course.onQueue">
                                <span class="font-weight-bold primary--text"><v-icon color="primary">mdi-check-bold</v-icon></span>
                                <div
                                  v-if="course.signupAmount > course.amount"
                                  class="text-caption orange--text mt-1"
                                  style="line-height: 1.1; font-weight: 700">
                                  Warteliste<br />offen
                                </div>
                              </div>
                              <div v-else-if="course.onQueue">
                                <v-progress-circular :value="100" color="orange" size="50" width="4">
                                  <div class="d-flex align-center orange--text">
                                    <v-icon small color="orange" class="mr-1">mdi-clipboard-clock</v-icon>
                                    <span class="font-weight-bold">{{ course.queuePosition }}</span>
                                  </div>
                                </v-progress-circular>
                                <div class="text-caption orange--text mt-1" style="line-height: 1.2">
                                  <span class="font-weight-bold">Warteliste</span><br />
                                  <span>Position</span>
                                </div>
                              </div>

                              <div v-else-if="course.signupAmount >= course.amount && !course.onQueue">
                                <v-progress-circular :value="100" color="#313131" size="50" width="4">
                                  {{ course.amount }}
                                </v-progress-circular>
                                <div class="text-caption mt-1" style="line-height: 1.2">
                                  <span style="color: #313131" class="font-weight-bold">ausgebucht</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-list-item-action>
                </v-list-item>
              </v-card>
            </div>
          </v-slide-y-transition>
        </div>
      </div>

      <router-view @updateCourse="fetchCourseList"></router-view>
    </div>
    <v-dialog
      v-model="showMaintenanceDialog"
      fullscreen
      persistent
      transition="dialog-bottom-transition"
      content-class="maintenance-fullscreen-dialog">
      <div class="maintenance-fullscreen-wrapper">
        <!-- Animierte Hintergrund-Glows für den Vibe -->
        <div class="ambient-glow glow-1"></div>
        <div class="ambient-glow glow-2"></div>

        <div class="maintenance-content-card">
          <div class="icon-pulse-container mb-6">
            <div class="radar-ring-1"></div>
            <div class="radar-ring-2"></div>
            <v-icon size="56" color="primary">mdi-hammer-wrench</v-icon>
          </div>

          <h2 class="maintenance-headline mb-3">Hier entsteht Grosses!</h2>

          <p class="maintenance-subline mb-8">
            Der neue Group Fitness Kursplan für <br />
            <span class="studio-highlight">{{ selectedStudio ? selectedStudio.name : "dieses Studio" }}</span> <br />
            wird gerade vorbereitet.
          </p>

          <v-btn x-large rounded class="maintenance-back-btn elevation-8 px-10" @click="$router.push('/')">
            <v-icon left>mdi-arrow-left</v-icon>
            Zurück
          </v-btn>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import api from "../../api"
import userService from "../../services/userService"
import courseListWeekly from "./courseListWeekly.vue"
import abortService from "../../services/abortService"
import { mapState, mapActions, mapGetters } from "vuex"
import { dragscroll } from "vue-dragscroll"
import { saveAs } from "file-saver"

export default {
  name: "courseList",
  components: { courseListWeekly },
  directives: { dragscroll },
  data: () => ({
    loadingFeedback: false,
    settings: {
      enableSignup: 3,
      signoffTimeLimit: 60,
      signupTimeLimit: 5,
      visibleDays: 6,
    },
    googleLinks: {
      winterthur: "https://search.google.com/local/writereview?placeid=ChIJ1-XTqeiZmkcRsRx_x9QBDuY",
      pfungen: "https://search.google.com/local/writereview?placeid=ChIJ64AfXp2emkcRCkjxabQ9aFw",
      buelach: "https://search.google.com/local/writereview?placeid=ChIJhxV5f8x1kEcR26FMoWG5Uf4",
      dietlikon: "https://search.google.com/local/writereview?placeid=ChIJj4wfdHOhmkcRyr1Y7GFARpY",
      frauenfeld: "https://search.google.com/local/writereview?placeid=ChIJ7-54hCGSmkcRDrc8TUMl_Qc",
      stgallenwest: "https://search.google.com/local/writereview?placeid=ChIJQ6On5CbgmkcRrgaGPGcMcOw",
      stgallenost: "https://search.google.com/local/writereview?placeid=ChIJ-zwNlF8em0cRc2mLZXW-74A",
      stgalleneinstein: "https://search.google.com/local/writereview?placeid=ChIJN1xUOJYfm0cRkU77L4F1fNg",
      netstal: "https://search.google.com/local/writereview?placeid=ChIJu_iZ1GothUcR4Y-IgO3rPcs",
      muri: "https://search.google.com/local/writereview?placeid=ChIJWYjHRhwFkEcRnZ1p3G7aMmQ",
      wil: "https://search.google.com/local/writereview?placeid=ChIJG0jVqoDpmkcRuUFfnvHXrE8",
      kreuzlingen: "https://search.google.com/local/writereview?placeid=ChIJ_ZUJeTr3mkcRvGOCVH94ZRo",
      frauefeldwest: "https://search.google.com/local/writereview?placeid=ChIJMQLkk5KRmkcRnUcwJLlktVM",
      arbon: "https://search.google.com/local/writereview?placeid=ChIJu9zMji0dm0cR-iqyVEBclc8",
      basel: "https://search.google.com/local/writereview?placeid=ChIJI_FXJ_K5kUcRLc9DflrHsZo",
      herisau: "https://search.google.com/local/writereview?placeid=ChIJR8GJASzemkcRH1sSS0jDOcI",
      niederurnen: "https://search.google.com/local/writereview?placeid=ChIJQ2XO3f7TmkcRNd7XIa-JVEs",
      obfelden: "https://search.google.com/local/writereview?placeid=ChIJrz8roHoGkEcRpdEg8jdGms0",
      oerlikon: "https://search.google.com/local/writereview?placeid=ChIJURt31IIKkEcRzSZLmDYIoDo",
      rikon: "https://search.google.com/local/writereview?placeid=ChIJb4z9Uj-XmkcRF3Nep-OuKqA",
      sirnach: "https://search.google.com/local/writereview?placeid=ChIJh5LPyA7rmkcRVfx67gTD4Gw",
      steckborn: "https://search.google.com/local/writereview?placeid=ChIJVxwbF3mLmkcR1x9w3-z4dIU",
      schwanden: "https://search.google.com/local/writereview?placeid=ChIJ0VSslTAvhUcRCeTL4u9X2Wc",
      wallisellen: "https://search.google.com/local/writereview?placeid=ChIJzQVcOzOhmkcRuhhXRQArsh8",
      wetzikon: "https://search.google.com/local/writereview?placeid=ChIJRVBvqcu7mkcR8MfxJIud_pE",
      wetzikonnord: "https://search.google.com/local/writereview?placeid=ChIJI2Jwe_C7mkcROGtE15U6vIw",
    },
    daycareClosed: false,
    rating: {
      _id: null,
      stars: 0,
      message: "",
      showGoogle: false,
      dontShowAnymore: false,
      showFeedbackBox: false,
      inputFeedbackBox: "",
    },
    originalPrimaryColor: null, // Hinzugefügt für das Theme-Management
    loadingKinderhort: true,
    daycareHours: null,
    loadingFeedback: false,
    courseListWeeklyKey: 0,
    visibleItems: [],
    showDaycare: false,
    arrivalTime: null,
    daycareTimeSlots: [],
    daycareSignups: { amount: 0, signedUp: false, signedUpAmount: 0 },
    daycareChildrenSelect: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],
    daycareBabiesSelect: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],
    showDaycareSelect: false,
    daycareSelection: "0",
    daycareBabiesSelection: "0",
    daycareSettings: null,
    showWeekly: false,
    abortController: null,
    datePicker: null,
    showDatePicker: false,
    currentDate: null,
    loadingCalendar: true,
    loading: true,
    calendar: [{}, {}, {}, {}, {}, {}, {}],
    userService,
    courseList: [],

    rating: {
      _id: null,
      stars: 0,
      message: "",
      showGoogle: false,
      dontShowAnymore: false,
      showFeedbackBox: false,
      inputFeedbackBox: "",
    },
  }),

  beforeRouteUpdate(to, from, next) {
    if (!this.$route.params.id) document.body.style = "overflow:auto;max-height:100vh;"
    next()
  },

  async mounted() {
    // Speichere die ursprüngliche Primärfarbe
    this.originalPrimaryColor = this.$vuetify.theme.themes.dark.primary
    // Setze die neue, leuchtende blaue Akzentfarbe
    this.$vuetify.theme.themes.dark.primary = "#00963f"
  },

  async created() {
    this.abortController = new abortService()
    document.body.style = "overflow:auto;max-height:100vh;"

    this.$emit("fetchNotifications")
    this.setNavigationBarText(null)
    this.setSelectedNavigation("groupFitness")
    if (!this.navigationVisible) this.toggleNavigationBarVisibility()

    // 1. Calendar laden (ohne dass es fetchCourseList triggert)
    await this.createCalendar()

    // 2. datePicker setzen - das triggert dann den einzigen Fetch
    if (this.alibeyStudio && this.calendar.length > 0) {
      const activeDay = this.calendar.find((c) => c.active) || this.calendar[0]
      this.datePicker = activeDay?.ts ? this.$moment.unix(activeDay.ts).format("YYYY-MM-DD") : this.$moment().format("YYYY-MM-DD")
    } else {
      this.datePicker = this.$moment().format("YYYY-MM-DD")
    }

    try {
      let tempSettings = await api.fetchGFCourseSettings()
      if (tempSettings.createdAt) {
        this.settings = tempSettings
      }
    } catch (e) {}
  },

  beforeDestroy() {
    // Setze die ursprüngliche Farbe wieder her, wenn die Ansicht verlassen wird
    this.$vuetify.theme.themes.dark.primary = this.originalPrimaryColor
    this.abortController.abort("Component destroyed")
  },

  methods: {
    ...mapActions("navigationStore", ["setSelectedNavigation"]),
    ...mapActions("navigationStoreNotPersisted", ["setNavigationBarText", "toggleNavigationBarVisibility", "setNavigationbarVisibility"]),
    openStudioSelection() {
      try {
        window.app.$root.$children[0].showStudioSelection = true
      } catch (e) {
        console.error("Studio-Auswahl konnte nicht geöffnet werden:", e)
      }
    },
    displayedSignupAmount(course) {
      // Wenn User angemeldet ist und Kurs überbucht ist (mehr Anmeldungen als Plätze),
      // zeigen wir visuell nur "amount/amount" statt z.B. "26/25" - das verwirrt sonst.
      // Die echte Wartelisten-Info kommt via Label "Warteliste offen" darunter.
      if (course.signedUp && !course.onQueue && course.signupAmount > course.amount) {
        return course.amount || 0
      }
      return course.signupAmount || 0
    },
    shouldShowClaimButton(courseView) {
      // 1. Basic Validation
      if (!courseView || !courseView.past || courseView.cancelled || !courseView.signups) {
        return false
      }

      // 2. Signup Check
      // Note: Hier ist hartcodiert '> 2'. Wenn du die Studio-Logik (2 oder 3) brauchst,
      // müsstest du hier auch auf den Studio-Code zugreifen wie im anderen Beispiel.
      const hasEnoughSignups = courseView.signups.length > 2
      const canAdminOverrideSignups = this.userService.hasRight("gf_claimforinstructor") || this.userService.hasRight("gf_showClaimInfo")

      if (!hasEnoughSignups && !canAdminOverrideSignups) {
        return false
      }

      // 3. Not-Claim Check
      if (this.userService.hasRight("gf_not_claim") && !this.userService.hasRight("gf_claimSelf")) {
        return false
      }

      // 4. DATE LOGIC (The Fix)
      // Wir ziehen den Check hier raus, damit er für ALLE gilt (Admin & Instructor)

      const courseDate = this.$moment(courseView.ts * 1000)

      // OPINION: Deine ursprüngliche Logik prüft: "Ist Kursdatum < Heute + 1 Monat?"
      // Das ist für alte Kurse immer TRUE. Du willst aber wahrscheinlich wissen:
      // "Ist HEUTE noch im Zeitrahmen (bis 1. des Folgemonats vom Kurs)?"
      // Ich habe die Logik hier korrigiert auf das, was du wahrscheinlich meinst:

      const claimDeadline = this.$moment(courseView.ts * 1000)
        .add(1, "months")
        .startOf("month")
      // Optional: .endOf('day') anhängen, wenn man den ganzen 1. Tag Zeit haben soll.

      const isOnTime = this.$moment().isSameOrBefore(claimDeadline)

      if (false && !isOnTime) {
        // Hier wird jetzt hart abgebrochen, egal wer der User ist
        return false
      }

      // 5. Final Eligibility
      // Da Date & Signups oben geklärt sind, prüfen wir nur noch die Rolle.
      const isEligibleUser = courseView.isInstructor || canAdminOverrideSignups

      let atLeastOneInstructor = !!courseView?.instructors?.[0]?.vorname

      return atLeastOneInstructor && isEligibleUser && !courseView.hoursClaimed
    },
    isLive(course) {
      const startDate = this.$moment(course.ts * 1000).set({ hours: course.hours, minutes: course.minutes })
      const endDate = this.$moment(course.ts * 1000)
        .set({ hours: course.hours, minutes: course.minutes })
        .add(course.duration, "minutes")
      return startDate.isSameOrBefore(this.$moment(), "minute") && endDate.isSameOrAfter(this.$moment(), "minutes")
    },
    // Diese Methoden zum methods: { ... } Objekt hinzufügen:
    getIndicatorColor(percentage) {
      return "primary"
      if (percentage <= 25) return "red darken-1"
      if (percentage <= 50) return "amber darken-1"
      return "primary"
    },
    toWeeklyView() {
      this.showDatePicker = false
      this.showWeekly = true
    },
    async abortRatingDialog(dialog) {
      if (this.rating.dontShowAnymore) {
        localStorage.setItem("hideGoogleRating", true)
      }
      this.rating._id = null
      this.rating.message = ""
      this.rating.stars = 0
      this.setNavigationbarVisibility(true)
      await this.fetchCourseList()
      dialog.value = false
    },

    hideGoogleRating() {
      this.rating.dontShowAnymore = false
      this.setNavigationbarVisibility(false)
      this.rating.showFeedbackBox = false
      this.rating.showGoogle = false
    },

    async sendFeedbackBox(dialog, courseId) {
      this.loadingFeedback = true
      await api.sendFeedbackBox(this.rating.inputFeedbackBox, "groupFitness", courseId).catch(() => {
        this.$toast.error("Fehler beim Senden des Feedbacks.")
        this.loadingFeedback = false
      })
      this.loadingFeedback = false
      dialog.value = false
    },

    async openGoogleRating() {
      if (this.rating.dontShowAnymore) {
        localStorage.setItem("hideGoogleRating", true)
      }
      const studioCode = this.selectedStudio?.code
      if (this.googleLinks[studioCode]) {
        window.open(this.googleLinks[studioCode], "_blank").focus()
      }
    },

    async sendRating(id, dialog) {
      this.loadingFeedback = true
      this.rating.dontShowAnymore = false
      if (this.rating.stars !== 0) {
        if (this.rating.stars <= 3 && (!this.rating.message || !this.rating.message.trim())) {
          this.$toast.error("Bitte gib einen Kommentar ein, weshalb du unzufrieden warst.")
          this.loadingFeedback = false
          return
        }
        this.rating._id = id
        const studioCode = this.selectedStudio?.code
        await api.sendGFRating({ rating: this.rating }).catch(() => {
          this.loadingFeedback = false
        })
        this.loadingFeedback = false
        if (this.rating.stars > 3) {
          if (studioCode && this.googleLinks[studioCode] && !localStorage.getItem("hideGoogleRating")) {
            this.rating.showGoogle = true
          } else {
            this.abortRatingDialog(dialog)
            this.triggerReview()
          }
        } else {
          this.rating.inputFeedbackBox = this.rating.message
          await this.sendFeedbackBox(dialog, id)
        }
      } else {
        this.$toast.error("Bitte wähle eine Bewertung aus.")
        this.loadingFeedback = false
      }
    },
    websocketHandler(data) {
      if (data.topic === "groupFitness" && data.courseExecution) {
        this.courseList.forEach((course) => {
          if (course._id.toString() === data.courseExecution.toString()) {
            if (data.type === "signup") course.signupAmount += 1
            if (data.type === "signoff") course.signupAmount -= 1
          }
        })
      }
    },

    handleMessage(data) {
      if (data.topic === "groupFitness" && data.type === "newAmount" && data.courseExecution) {
        this.courseList.forEach((course) => {
          if (course._id.toString() === data.courseExecution.toString()) {
            course.signupAmount = data.amount ?? 0
          }
        })
      }
    },

    async signupDaycare() {
      // Variable, um die Gesamtanzahl der Kinder zu speichern
      let childPackageAmount = 0

      // 1. Check, ob es sich um einen Premium-Hauptvertrag handelt
      const mainContractTitle = this.activeContractDetails?.title?.toLowerCase() || ""

      // Überprüfen, ob activeContractDetails und addons existieren, um Fehler zu vermeiden
      if (mainContractTitle.includes("premium")) {
        // Meine Meinung: Wenn "Premium" gesetzt ist, überschreiben wir die Logik und setzen fix 4 Plätze
        childPackageAmount = 4
      } else if (this.activeContractDetails && this.activeContractDetails.addons) {
        // Durch jedes Addon im Vertrag loopen
        for (const addon of this.activeContractDetails.addons) {
          const title = addon.title.toLowerCase() // Titel in Kleinbuchstaben für einen zuverlässigen Vergleich

          // Prüfen, ob der Titel "kinderhort" enthält
          if (title.includes("kinderhort")) {
            // Versuchen, eine oder mehrere Ziffern (\d+) im Titel zu finden
            const matches = title.match(/\d+/)

            // Wenn eine Zahl gefunden wird, wandle sie in eine Ganzzahl um.
            // Wenn keine Zahl gefunden wird (z.B. bei "Kinderhort"), nimm 1 als Standardwert.
            const numChildren = matches ? parseInt(matches[0], 10) : 1

            // Addiere die gefundene Kinderanzahl zur Gesamtsumme
            childPackageAmount += numChildren
          }
        }
      }

      if (!this.arrivalTime) {
        return this.$toast.error("Bitte wähle eine Ankunftszeit aus")
      }
      const ts = this.$moment(this.datePicker).unix()
      if (!ts) return

      const signup = {
        date: this.$moment.unix(ts).format("YYYY-MM-DD"),
        signup: {
          date: this.$moment().format(),
          amountChildren: this.daycareSelection,
          amountBabies: this.daycareBabiesSelection,
          arrivalTime: this.arrivalTime,
          active: true,
          childPackageAmount,
        },
      }
      await api.signupDaycare(signup)
      this.fetchKinderhortSignups(false)
      this.showDaycareSelect = false
    },

    async fetchKinderhortSignups(loading = true) {
      if (loading) this.loadingKinderhort = true
      const ts = this.alibeyStudio ? this.calendar.find((c) => c.active)?.ts : this.$moment(this.datePicker).unix()
      if (!ts) {
        this.loadingKinderhort = false
        return
      }
      const signups = await api.fetchDaycareSignups(this.$moment.unix(ts).format("YYYY-MM-DD"))
      if (signups) {
        this.daycareSignups = signups
        this.daycareSelection = signups.signedUpAmount.toString()
        this.daycareBabiesSelection = signups.signedUpBabiesAmount.toString()
        this.arrivalTime = signups.arrivalTime
      } else {
        this.daycareSignups = { amount: 0, signedUp: false, signedUpAmount: 0, signedUpBabiesAmount: 0 }
        this.daycareSelection = "0"
        this.daycareBabiesSelection = "0"
      }
      this.loadingKinderhort = false
    },

    // in methods: { ... }

    async fetchKinderhortHours() {
      this.daycareSelection = "0"
      this.daycareBabiesSelection = "0"
      this.daycareHours = ""
      this.daycareTimeSlots = []
      this.showDaycare = false
      this.daycareClosed = false // NEU: Variable initialisieren

      // --- START: NEUE PRÜFUNG HINZUGEFÜGT ---

      // Hole den Timestamp des ausgewählten Datums
      const ts = this.$moment(this.datePicker).unix()

      // Definiere die Zeitgrenzen
      const selectedDate = this.$moment.unix(ts).startOf("day")
      const today = this.$moment().startOf("day")
      const limitDate = this.$moment().add(3, "days").startOf("day")

      // Prüfe, ob das Datum ausserhalb des erlaubten Bereichs liegt
      if (selectedDate.isBefore(today) || selectedDate.isAfter(limitDate)) {
        // Wenn ja: Lade-Indikator ausschalten und Funktion sofort beenden.
        // Der Kinderhort wird nicht geladen und nicht angezeigt.
        this.loadingKinderhort = false
        return
      }
      // --- ENDE: NEUE PRÜFUNG HINZUGEFÜGT ---

      const openingHours = await api.fetchBusinessHours("kinderhort").catch(() => null)

      if (!openingHours || !openingHours.active) {
        this.loadingKinderhort = false
        return
      }

      this.daycareSettings = openingHours
      // Die ts-Ermittlung von hier wurde nach oben verschoben für die neue Prüfung
      if (!ts) {
        this.loadingKinderhort = false
        return
      }

      const dayOfWeek = this.$moment.unix(ts).weekday()
      const dayName = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"][dayOfWeek]
      const hours = openingHours.days[dayName]

      if (hours) {
        const openSlots = hours.filter((e) => e.isOpen && (e.open || e.close))
        if (openSlots.length > 0) {
          // --- START: NEU - PRÜFEN, OB HEUTE SCHON GESCHLOSSEN IST ---
          if (selectedDate.isSame(today)) {
            // Finde die späteste Schliesszeit des Tages
            const lastCloseTime = Math.max(...openSlots.map((o) => parseInt(o.close, 10)))
            const lastCloseStr = lastCloseTime.toString().padStart(4, "0")

            // Erstelle ein Moment-Objekt für die Schliesszeit
            const closingMoment = this.$moment()
              .hour(parseInt(lastCloseStr.slice(0, 2), 10))
              .minute(parseInt(lastCloseStr.slice(2, 4), 10))

            // Vergleiche die aktuelle Zeit mit der Schliesszeit
            if (this.$moment().isAfter(closingMoment)) {
              this.daycareClosed = true
            }
          }
          // --- ENDE: NEU ---

          this.daycareHours = openSlots
            .map((o) => `${o.open.slice(0, 2)}:${o.open.slice(2, 4)} - ${o.close.slice(0, 2)}:${o.close.slice(2, 4)} Uhr`)
            .join("<br>")

          openSlots.forEach((o) => {
            let slot = this.$moment.unix(ts).set({ hour: parseInt(o.open.slice(0, 2)), minute: parseInt(o.open.slice(2, 4)) })
            let end = this.$moment
              .unix(ts)
              .set({ hour: parseInt(o.close.slice(0, 2)), minute: parseInt(o.close.slice(2, 4)) })
              .subtract(30, "minutes")
            while (slot.isSameOrBefore(end)) {
              this.daycareTimeSlots.push(slot.format("HH:mm"))
              slot.add(30, "minutes")
            }
          })

          this.showDaycare = true
          await this.fetchKinderhortSignups()
        }
      }
      this.loadingKinderhort = false
    },
    swipe(direction) {
      const momentDate = this.$moment(this.datePicker)
      if (direction === "Right") {
        this.datePicker = momentDate.subtract(1, "days").format("YYYY-MM-DD")
      } else {
        this.datePicker = momentDate.add(1, "days").format("YYYY-MM-DD")
      }
    },

    getMarkerColor(course) {
      if (course.cancelled) return "#D32F2F"
      if (course.signedUp) return "var(--v-primary-base)"
      // HIER DIE NEUE ZEILE EINFÜGEN
      if (course?.course?._id && this.courseRecommendations.includes(course.course._id)) return "#FBC02D" // Kräftiges Gelb/Gold
      if (course?.course?.slimMe) return "#0288D1"

      const percentage = 100 - this.calcPercentage(course)
      if (percentage > 66) return "var(--v-primary-base)"
      if (percentage > 33) return "#F57C00"
      return "#D32F2F"
    },

    formatDate(date) {
      if (!date) return ""
      const momentDate = this.$moment(date)
      if (momentDate.isSame(this.$moment(), "day")) return "Heute"
      if (momentDate.isSame(this.$moment().add(1, "day"), "day")) return "Morgen"
      return momentDate.format("dd, DD. MMM")
    },
    calcPercentage(course) {
      if (course.amount > 0) {
        const free = Math.max(0, course.amount - (course.signupAmount || 0))
        return Math.round((free / course.amount) * 100)
      }
      return 100
    },

    pushToCourse(course) {
      if (
        course.past &&
        !this.userService.hasRight("gf_c_edit", "gf_c_delete", "gf_c_plan", "gf_c_create", "gf_cp_edit", "gf_f_courses") &&
        !this.userService.hasRight("gf_cp_viewPastCourses") &&
        !this.userService.hasRight("gf_claimSelf")
      ) {
        return
      }
      let ts = this.$moment(this.datePicker).unix()
      if (course.courseTimelineId) ts = 0

      document.body.style = "overflow:hidden;max-height:100vh;"
      this.$router.push({ name: "courseListView", params: { id: course._id, ts } })
    },

    courseEndDate(course) {
      return this.$moment().set({ hours: course.hours, minutes: course.minutes }).add(course.duration, "minutes").format("HH:mm")
    },

    courseStartDate(course) {
      return this.$moment().set({ hours: course.hours, minutes: course.minutes }).format("HH:mm")
    },

    showDivider(y) {
      if (y > 0 && this.courseList[y] && this.courseList[y - 1]) {
        return this.courseList[y].hours !== this.courseList[y - 1].hours
      }
      return true
    },

    async createCalendar() {
      this.loadingCalendar = true
      this.calendar = await api.fetchCourseCalendar(this.abortController.signal)
      this.loadingCalendar = false
    },

    setCalendarDate(i) {
      this.loading = true
      this.courseList = []
      this.calendar.forEach((c, y) => {
        c.active = y === i
      })
      return true
    },

    async fetchCourseList() {
      this.loading = true
      this.loadingKinderhort = true
      if (this.showWeekly) this.courseListWeeklyKey += 1

      let ts = this.$moment(this.datePicker).unix()
      if (!ts) {
        this.loading = false
        this.loadingKinderhort = false
        return
      }

      await this.fetchKinderhortHours()

      this.courseList = await api.fetchCourseList(this.abortController.signal, ts)
      this.loading = false
    },
  },

  watch: {
    datePicker() {
      this.showDatePicker = false // Schliesst das Kalender-Pop-up
      this.fetchCourseList()
    },
  },

  computed: {
    ...mapGetters("userStore", ["courseRecommendations", "activeContractDetails"]),
    ...mapState("navigationStoreNotPersisted", ["navigationVisible"]),
    ...mapState("studioStore", ["selectedStudio"]),
    lockedStudios() {
      // Hier einfach alle Codes eintragen, die den Sperrbildschirm sehen sollen
      return ["berg"]
    },

    showMaintenanceDialog() {
      // 1. Wenn der User Admin-Rechte hat, Dialog NIEMALS anzeigen
      if (this.userService.hasRight("gf_f_courses")) return false

      // 2. Prüfen, ob das aktuell gewählte Studio in der Sperrliste ist
      if (!this.selectedStudio || !this.selectedStudio.code) return false

      const code = this.selectedStudio.code.toLowerCase()
      return this.lockedStudios.includes(code)
    },
    isAdmin() {
      return this.userService.hasRight("gf_c_edit", "gf_c_delete", "gf_c_plan", "gf_c_create", "gf_cp_edit", "gf_f_courses")
    },
    freeSpots() {
      return (course) => {
        if (course.amount) {
          return Math.max(0, course.amount - course.signupAmount)
        }
        return "∞" // Bei unbegrenzter Kapazität
      }
    },
    customerDateRange() {
      if (this.userService.hasRight("gf_c_edit")) return [] // Für Admins nicht nötig

      const dates = []
      // Wir benutzen die bereits existierende minDate/maxDate Logik
      let currentDate = this.$moment(this.minDate)
      const endDate = this.$moment(this.maxDate)

      while (currentDate.isSameOrBefore(endDate, "day")) {
        dates.push({
          value: currentDate.format("YYYY-MM-DD"),
          // Wir verwenden die formatDate Methode, um "Heute", "Morgen" etc. zu bekommen
          text: this.formatDate(currentDate.format("YYYY-MM-DD")),
        })
        currentDate.add(1, "days")
      }
      return dates
    },

    isPrevDayDisabled() {
      // Wenn es kein minDate gibt (z.B. für Admins), nie disablen.
      if (!this.minDate) return false
      // Gibt true zurück, wenn das gewählte Datum HEUTE oder FRÜHER ist.
      return this.$moment(this.datePicker).isSameOrBefore(this.minDate, "day")
    },

    isNextDayDisabled() {
      // Wenn es kein maxDate gibt (z.B. für Admins), nie disablen.
      if (!this.maxDate) return false
      // Gibt true zurück, wenn das gewählte Datum am End-Datum oder SPÄTER ist.
      return this.$moment(this.datePicker).isSameOrAfter(this.maxDate, "day")
    },
    minDate() {
      if (this.alibeyStudio && this.calendar.length > 0) {
        return this.$moment.unix(this.calendar[0].ts).format("YYYY-MM-DD")
      }
      if (this.userService.hasRight("gf_f_courses")) return null
      return this.$moment().subtract(1, "days").format("YYYY-MM-DD")
    },
    maxDate() {
      if (this.alibeyStudio && this.calendar.length > 0) {
        return this.$moment.unix(this.calendar[this.calendar.length - 1].ts).format("YYYY-MM-DD")
      }
      if (this.userService.hasRight("gf_f_courses")) return null
      if (this.userService.hasRight("gf_cp_manageSignups")) return this.$moment().add(14, "days").format("YYYY-MM-DD")
      if (this.settings.visibleDays) return this.$moment().add(this.settings.visibleDays, "days").format("YYYY-MM-DD")
      return this.$moment().add(6, "days").format("YYYY-MM-DD")
    },
    daycareSignedUp() {
      return (
        this.daycareSignups?.signedUp &&
        (this.daycareSignups?.amount > 0 ||
          this.daycareSignups?.signedUpAmount ||
          this.daycareSignups?.signedUpAmount ||
          this.daycareSignups?.signedUpBabiesAmount)
      )
    },
    linkPreview() {
      return window.location.href.includes("local") ? "https://app.wellcomefit.ch" : ""
    },
    schwandenStudio() {
      return this.selectedStudio?.code === "schwanden"
    },

    alibeyStudio() {
      const code = this.selectedStudio?.code.toLowerCase()
      return code === "alibey" || code === "ali"
    },
  },
}
</script>

<style lang="scss" scoped>
// In den <style lang="scss" scoped> Block einfügen
.room-badge {
  display: inline-flex;
  align-items: center;
  background-color: #f0f2f5; // Ein sehr sanftes Grau-Blau
  color: #4a5568; // Dunkleres Grau für perfekten Kontrast
  padding: 4px 10px;
  border-radius: 8px; // Schöne weiche Ecken
  font-size: 0.8rem;
  font-weight: 600;
}

.v-list-item__title {
  font-size: 1.2rem !important;
}

.date-list-item:hover {
  background-color: rgba(0, 0, 0, 0.04);
}

.course-list-inner-wrapper {
  max-width: 500px;
  margin: auto;
  position: relative;
}

.additional-info {
  font-style: italic;
  // Eine freundliche blaue Farbe für Info-Text
  font-size: 0.85rem !important;
}

// ===================================================================
//  KEYFRAME-ANIMATIONEN
// ===================================================================
@keyframes float-bob {
  0% {
    transform: translateY(0px);
  }

  50% {
    transform: translateY(-8px);
  }

  100% {
    transform: translateY(0px);
  }
}

// ===================================================================
//  1. ALLGEMEINES LAYOUT & SEITEN-HINTERGRUND
// ===================================================================
.view-toggle-fab {
  position: absolute;
  top: 12px;

  right: 12px;
  z-index: 10; // Stellt sicher, dass er über anderen Elementen liegt
}

.course-list-wrapper {
  // Ein sehr heller, kühler Grauton lässt weisse Elemente richtig strahlen.
  background-color: var(--v-appBackground);
  min-height: 100vh;
}

.daily-view-container {
  padding-bottom: 120px;
}

// ===================================================================
//  2. DAS NEUE "CONTROL PANEL" (Datumswahl & Toggle)
// ===================================================================
.view-toggle-container {
  padding: 8px 0;
}

.date-picker-card {
  background: transparent !important;
  box-shadow: none !important;

  .v-card-actions .v-btn {
    --v-btn-height: 48px; // Grössere, leichter zu treffende Buttons
    border-radius: 14px;

    &:hover {
      background-color: rgba(0, 0, 0, 0.05);
    }
  }
}

// ===================================================================
//  3. DAS NEUE, SOLIDE KARTEN-DESIGN
// ===================================================================
.course-card.is-cancelled {
  opacity: 0.6;
  background-color: #f5f5f5 !important;
  /* Heller, grauer Hintergrund */
}

/* NEUE Regel für vergangene Kurse */
.course-card.is-past {
  opacity: 0.7;
  filter: saturate(50%);
  /* Entsättigt die Farben leicht */
}

/* NEUE Regel für den Status-Chip */
.status-chip {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 2;
  font-weight: bold;
}

.course-card {
  width: 100%;
  background: #ffffff !important;
  border-radius: 24px !important;
  border: 1px solid #ededf0;

  // Ein tiefer, weicher Schatten für einen "schwebenden" Effekt.
  box-shadow: 0 4px 12px rgba(0, 20, 50, 0.05), 0 10px 30px rgba(0, 20, 50, 0.07);

  transition: transform 0.3s cubic-bezier(0.25, 0.8, 0.25, 1), box-shadow 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);

  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 6px 16px rgba(0, 20, 50, 0.08), 0 15px 40px rgba(0, 20, 50, 0.1);
  }

  &.signed-up {
    // Ein klarer, dicker Rand in der Akzentfarbe für angemeldete Kurse.
    border: 2px solid var(--v-primary-base, #00963f);
    box-shadow: 0 4px 12px rgba(0, 150, 63, 0.5), 0 10px 30px rgba(0, 150, 63, 0.1);
  }

  &.on-queue {
    // Ein klarer, dicker Rand in der Akzentfarbe für angemeldete Kurse.
    border: 2px solid rgb(255, 165, 0);
    box-shadow: 0 4px 12px rgba(255, 165, 0, 0.5), 0 10px 30px rgba(255, 165, 0, 0.1);
  }

  &.cancelled {
    opacity: 0.65;
    filter: grayscale(50%);
  }
}

// ===================================================================
//  4. DIE HERAUSSTECHENDE KINDERHORT-KARTE (AKTUALISIERT)
// ===================================================================
.kinderhort-card {
  border-radius: 24px !important;
  background: var(--v-primary-base, #00963f) !important;
  box-shadow: 0 10px 30px rgba(var(--v-primary-rgb), 0.4);
  color: white !important;
  border: none;
  // Wichtig: Relative Position für die absoluten Elemente
  position: relative;

  .v-card-title,
  .v-card-subtitle {
    color: white !important;
    position: relative; // Stellt sicher, dass der Text über dem Icon-Wrapper liegt
    z-index: 1;
    // Verhindert, dass Text unter die Icons läuft
    padding-right: 90px;
  }

  .v-card-title {
    font-weight: 900;
  }

  .v-card-actions {
    position: absolute; // Button am unteren Rand positionieren
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 2;
  }

  // Neuer Style für unseren Haupt-Button
  .cta-button {
    font-weight: 700 !important; // Starke Schrift
    border-radius: 16px !important; // Weiche Ecken
    text-transform: none; // Lesbarer machen
    letter-spacing: 0.5px;
    // Leichter Schatten, um den Button vom Hintergrund abzuheben
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    transition: transform 0.2s ease-out, box-shadow 0.2s ease-out;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    }
  }

  .cta-button.v-btn--disabled {
    background-color: #ffffff !important;
    color: rgb(0 0 0 / 50%) !important;

    .v-icon {
      color: rgb(0 0 0 / 50%) !important;
    }
  }

  .kinderhort-icon-wrapper {
    position: absolute;
    top: 10px;
    right: 5px;
    opacity: 0.9; // Leicht transparent, um nicht zu sehr vom Text abzulenken
    z-index: 0; // Hinter dem Text

    .icon,
    .icon2 {
      filter: drop-shadow(0 5px 15px rgba(0, 0, 0, 0.25));
      animation: float-bob 7s ease-in-out infinite;
    }

    .icon {
      width: 85px;
    }

    .icon2 {
      margin-left: -20px;
      width: 65px;
      animation-delay: -3.5s;
    }
  }
}

// Alten, nicht mehr benötigten Stil entfernen oder anpassen
// .v-btn.kinderhort-signup-btn { ... } // Dieser Block kann weg
// ===================================================================
//  5. POLIERTE UI-ELEMENTE & TYPOGRAFIE
// ===================================================================
.v-list-item-title {
  font-weight: 700; // Ein kräftiges "Bold" statt "Black"
  color: #1a232e !important;
  font-size: 1.1rem;
}

.v-list-item-subtitle {
  color: #5a6470 !important;
  font-size: 0.9rem;
}

.course-avatar {
  background-color: #f7f8fa;
  border-radius: 18px;
  border: 1px solid #ededf0;
}

// Zeit-Trenner neu gestaltet für einen saubereren Look.
.time-divider {
  padding: 24px 16px 8px;

  .time-chip {
    background-color: #e9ebf0;
    color: #5a6470;
    font-weight: 1000;

    font-size: 0.8rem;
    padding: 6px 14px;
    border-radius: 20px;
  }
}

.course-label {
  position: absolute;
  top: -5px;
  width: 100%;
  left: 0px; // Leicht ausserhalb für einen "Banner"-Effekt
  padding: 4px 10px 4px 12px;
  color: white;
  font-weight: 700;
  font-size: 0.75rem;
  text-align: center;

  text-transform: uppercase;
  z-index: 2;
}

// Den Wartelisten-Chip etwas anpassen, damit er nicht mit dem Label kollidiert
.queue-chip {
  position: static;
  top: 16px;
  right: 16px;
  border-radius: 8px;
  font-weight: 600;
  z-index: 2; // Sicherstellen, dass er über allem ist
}

// Der FAB (Floating Action Button) bleibt prominent
.fab-admin-edit {
}

// ===================================================================
//  BEWERTEN BUTTON & DIALOG
// ===================================================================
.rate-btn {
  background: linear-gradient(135deg, #fff8e1 0%, #ffecb3 100%) !important;
  color: #f57f17 !important;
  border-radius: 14px !important;
  font-weight: 700 !important;
  text-transform: none !important;
  letter-spacing: 0.2px !important;
  padding: 0 16px !important;
  height: 38px !important;
  box-shadow: 0 2px 8px rgba(245, 127, 23, 0.18), inset 0 0 0 1px rgba(245, 127, 23, 0.15) !important;
  transition: all 0.25s ease !important;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 14px rgba(245, 127, 23, 0.28), inset 0 0 0 1px rgba(245, 127, 23, 0.25) !important;
  }

  .v-icon {
    color: #f9a825 !important;
  }
}

.rate-dialog {
  border-radius: 28px !important;
  overflow: hidden !important;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25) !important;
}

.rate-card {
  border-radius: 28px !important;
  overflow: hidden;
}

.rate-header {
  background: linear-gradient(135deg, #00963f 0%, #00b84c 100%);
  padding: 22px 24px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  position: relative;

  &::after {
    content: "";
    position: absolute;
    top: -40px;
    right: -40px;
    width: 140px;
    height: 140px;
    background: rgba(255, 255, 255, 0.08);
    border-radius: 50%;
  }

  .rate-header-content {
    flex: 1;
    z-index: 1;
  }

  .rate-course-name {
    color: white;
    font-size: 1.25rem;
    font-weight: 800;
    line-height: 1.2;
  }

  .rate-course-meta {
    color: rgba(255, 255, 255, 0.85);
    font-size: 0.88rem;
    margin-top: 4px;
  }

  .rate-close {
    z-index: 2;
  }
}

.rate-question {
  font-size: 1.05rem;
  font-weight: 700;
  color: #1a232e;
}

.rate-cancel {
  text-transform: none !important;
  color: #5a6470 !important;
  font-weight: 600 !important;
}

.rate-submit {
  background: linear-gradient(135deg, #00963f 0%, #00b84c 100%) !important;
  color: white !important;
  border-radius: 14px !important;
  text-transform: none !important;
  font-weight: 700 !important;
  letter-spacing: 0.3px !important;
  padding: 0 22px !important;
  box-shadow: 0 4px 14px rgba(0, 150, 63, 0.35) !important;
  transition: all 0.25s ease !important;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 18px rgba(0, 150, 63, 0.45) !important;
  }
}
// ===================================================================
//  ALIBEY "IN VORBEREITUNG" DIALOG
// ===================================================================
.alibey-dialog {
  border-radius: 28px !important;
  overflow: hidden !important;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3) !important;
}

.alibey-card {
  border-radius: 28px !important;
  overflow: hidden;
  text-align: center;
}

.alibey-header {
  background: linear-gradient(135deg, #00963f 0%, #00b84c 100%);
  padding: 32px 24px 40px;
  position: relative;

  &::after {
    content: "";
    position: absolute;
    top: -60px;
    right: -60px;
    width: 180px;
    height: 180px;
    background: rgba(255, 255, 255, 0.08);
    border-radius: 50%;
  }

  &::before {
    content: "";
    position: absolute;
    bottom: -40px;
    left: -40px;
    width: 120px;
    height: 120px;
    background: rgba(255, 255, 255, 0.06);
    border-radius: 50%;
  }
}

.alibey-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 90px;
  height: 90px;
  margin: 0 auto;
  background: rgba(255, 255, 255, 0.18);
  border-radius: 50%;
  position: relative;
  z-index: 1;
  backdrop-filter: blur(10px);
  border: 2px solid rgba(255, 255, 255, 0.3);

  .v-icon {
    animation: float-bob 4s ease-in-out infinite;
  }
}

.alibey-title {
  font-weight: 900 !important;
  font-size: 1.5rem !important;
  color: #1a232e !important;
  justify-content: center !important;
  padding: 24px 24px 12px !important;
  word-break: normal !important;
}

.alibey-text {
  font-size: 1rem !important;
  color: #5a6470 !important;
  padding: 0 28px 24px !important;
  line-height: 1.5;
}

.alibey-btn {
  background: linear-gradient(135deg, #00963f 0%, #00b84c 100%) !important;
  color: white !important;
  border-radius: 16px !important;
  font-weight: 700 !important;
  text-transform: none !important;
  letter-spacing: 0.3px !important;
  box-shadow: 0 4px 14px rgba(0, 150, 63, 0.35) !important;
  transition: all 0.25s ease !important;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 150, 63, 0.45) !important;
  }
}

// ===================================================================
//  SEXY FULLSCREEN MAINTENANCE SCREEN
// ===================================================================
.maintenance-fullscreen-dialog {
  background: #0f1115 !important; // Sattes, tiefes Dark-Mode-Anthrazit
}

.maintenance-fullscreen-wrapper {
  position: relative;
  width: 100vw;
  height: 100vh;
  background: #0f1115;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 24px;
}

// Sphärische Hintergrund-Lichter
.ambient-glow {
  position: absolute;
  border-radius: 50%;
  filter: blur(100px);
  opacity: 0.15;
  pointer-events: none;
  z-index: 0;

  &.glow-1 {
    top: -10%;
    right: -10%;
    width: 400px;
    height: 400px;
    background: radial-gradient(circle, var(--v-primary-base, #00963f) 0%, transparent 70%);
  }

  &.glow-2 {
    bottom: -10%;
    left: -10%;
    width: 500px;
    height: 500px;
    background: radial-gradient(circle, #00b84c 0%, transparent 70%);
  }
}

// Content-Card (Schwebendes Glas)
.maintenance-content-card {
  position: relative;
  z-index: 1;
  max-width: 420px;
  width: 100%;
  text-align: center;
  padding: 40px 32px;
  background: rgba(255, 255, 255, 0.03);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 32px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
}

// Animiertes Puls-Icon
.icon-pulse-container {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 100px;
  background: rgba(var(--v-primary-rgb, "0, 150, 63"), 0.12);
  border: 1px solid rgba(var(--v-primary-rgb, "0, 150, 63"), 0.3);
  border-radius: 50%;

  .v-icon {
    animation: wrench-float 3s ease-in-out infinite;
    z-index: 2;
  }

  [class^="radar-ring-"] {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border: 2px solid var(--v-primary-base, #00963f);
    border-radius: 50%;
    opacity: 0;
    z-index: 1;
  }

  .radar-ring-1 {
    animation: radar-pulse 2.5s cubic-bezier(0.215, 0.61, 0.355, 1) infinite;
  }
  .radar-ring-2 {
    animation: radar-pulse 2.5s cubic-bezier(0.215, 0.61, 0.355, 1) infinite;
    animation-delay: 1.25s;
  }
}

// Typografie
.maintenance-headline {
  color: #ffffff;
  font-size: 1.75rem;
  font-weight: 900;
  letter-spacing: -0.5px;
  text-transform: uppercase;
  font-style: italic;
}

.maintenance-subline {
  color: #9aa2ae;
  font-size: 1.05rem;
  line-height: 1.5;
  font-weight: 500;

  .studio-highlight {
    color: #ffffff;
    font-weight: 800;
    font-size: 1.2rem;
    display: inline-block;
    padding: 2px 0;
  }
}

// Sexy Action Button
.maintenance-back-btn {
  background: linear-gradient(135deg, var(--v-primary-base, #00963f) 0%, #00b84c 100%) !important;
  color: #ffffff !important;
  font-weight: 800 !important;
  font-size: 0.95rem !important;
  text-transform: uppercase !important;
  letter-spacing: 1px !important;
  border-radius: 18px !important;
  width: 100%;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1) !important;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 12px 24px rgba(0, 150, 63, 0.4) !important;
  }

  &:active {
    transform: translateY(-1px);
  }
}

// ===================================================================
//  KEYFRAMES
// ===================================================================
@keyframes wrench-float {
  0%,
  100% {
    transform: translateY(0) rotate(0deg);
  }
  50% {
    transform: translateY(-4px) rotate(8deg);
  }
}

@keyframes radar-pulse {
  0% {
    transform: scale(1);
    opacity: 0.5;
  }
  100% {
    transform: scale(1.4);
    opacity: 0;
  }
}
</style>
